import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { INIT_PAGESIZE } from 'commons/constants';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useLecturer = () => {
  /* ======================================================
   * state
   * ====================================================== */
  const [lecturerList, setLecturerList] = useState<LecturerListDto[]>();
  const [searchResult, setSearchResult] = useState({ pageNo: 0, pageSize: INIT_PAGESIZE, totalCount: 0 });

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  const { isLoading, refetch } = useQuery(
    [endpoints.lecturer.list, location.search],
    () =>
      fetcher.lecturer.postLecturerList({
        pageNo: Number(searchParams.pageNo) || 1,
        pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
        searchValue: searchParams.search ? String(searchParams.search) : '',        
        lecturer_type: searchParams.lecturer_type ? String(searchParams.lecturer_type) : '',
        lecturer_category: searchParams.lecturer_category ? String(searchParams.lecturer_category) : '',        
      }),
    {
      onSuccess: (res: LecturerListResDto) => {
        switch (res.code) {
          case 200:
            setLecturerList(res.result?.list);
            setSearchResult({
              pageNo: res.result?.pageNo || 1,
              pageSize: res.result?.pageSize || INIT_PAGESIZE,
              totalCount: res.result?.totalCount || 0,
            });
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: lecturerFileUpdate } = useMutation(
    [endpoints.lecturer.filesave],
    fetcher.lecturer.postLecturerFileUpdate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  const { mutate: lecturerActivate } = useMutation(
    [endpoints.lecturer.activate],
    fetcher.lecturer.postLecturerActivate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  return { isLoading, lecturerList, searchResult, refetch, lecturerFileUpdate, lecturerActivate};
};

export default useLecturer;
